
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"22","viewBox":"0 0 30 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.677 6.234A6.005 6.005 0 0024.093.239 182.285 182.285 0 005.835.22C2.869.218.229 3.078.229 6.233a45.948 45.948 0 000 9.17 5.595 5.595 0 005.553 5.606c3.05.169 6.107.253 9.171.253 3.064 0 6.104-.08 9.118-.242a5.616 5.616 0 005.606-5.532c.43-3.07.43-6.185 0-9.255zm-2.103 9.076a.512.512 0 000 .126 3.534 3.534 0 01-3.566 3.513c-6.053.316-12.12.316-18.173 0a3.535 3.535 0 01-3.502-3.618c-.3-2.961-.3-5.946 0-8.908a.473.473 0 000-.115 3.975 3.975 0 013.555-3.986c3.007-.137 6.036-.2 9.065-.2 3.03 0 6.058.063 9.066.2h.052c1.799 0 3.503 1.935 3.503 3.986a.8.8 0 000 .157 31.666 31.666 0 010 8.824v.021z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M19.991 9.925l-7.509-3.87a1.054 1.054 0 00-.967 1.872l5.71 2.934-4.207 2.177v-2.177a1.052 1.052 0 00-2.103 0v3.913a1.051 1.051 0 001.536.936l7.509-3.913a1.052 1.052 0 00.568-.936 1.053 1.053 0 00-.537-.936z","fill":"#E2E8F0"}})])
          )
        }
      }
    